import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  userIsAdmin,
  userIsManager,
} from '../helpers/Auth';

import { showModal } from '../actions';
import { setLoggedIn } from '../actions/App';

const UpgradeButton = ({
  history,
  client,
  loggedIn,
  handleModal,
}) => {
  const intl = useIntl();

  const handleClick = () => {
    if (client.trial_ends_at) {
      history.push('/admin/settings/subscription');
    } else {
      handleModal();
    }
  };

  if (!client.is_free || !(userIsAdmin() || userIsManager())) {
    return null;
  }

  if (loggedIn && !client.trial_ends_at) {
    handleModal();
  }

  return (
    <Button
      color="secondary"
      size="md"
      className="upgrade-button"
      onClick={handleClick}
    >
      <i className="far fa-circle-arrow-up" />
      <span>
        {client.trial_ends_at ? (
          intl.formatMessage({ defaultMessage: 'Upgrade' })
        ) : (
          intl.formatMessage({ defaultMessage: 'Unlock Premium for 14 days' })
        )}
      </span>
    </Button>
  );
};

const mapStateToProps = state => ({
  client: state.Auth.profile?.client,
  loggedIn: state.App.loggedIn,
});

const mapDispatchToProps = dispatch => ({
  handleModal: () => {
    dispatch(setLoggedIn(false));
    dispatch(showModal('TrialModal', {
      className: 'modal-start-trial',
    }));
  },
});

UpgradeButton.propTypes = {
  history: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  handleModal: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UpgradeButton));
